var React = require('react');

function SimCard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 192H96a32 32 0 0 0-32 32v32h64zM64 416a32 32 0 0 0 32 32h32v-64H64zm160-224h-64v64h64zm32 256h32a32 32 0 0 0 32-32v-32h-64zm-96 0h64v-64h-64zm128-256h-32v64h64v-32a32 32 0 0 0-32-32zM64 352h256v-64H64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 0H64A64.06 64.06 0 0 0 0 64v384a64.06 64.06 0 0 0 64 64h256a64.06 64.06 0 0 0 64-64V128zm64 416a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

SimCard.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = SimCard;

SimCard.default = SimCard;
